// extracted by mini-css-extract-plugin
export var formContainer = "_mc-0";
export var message = "_mc-1";